<template>
  <v-dialog v-model="dialog" persistent lazy absolute>
    <v-btn outline large class="secondary secondary--text mx-0" slot="activator">
      <slot>Marcar como realizada</slot>
    </v-btn>
    <v-card>
      <v-card-title>
        <div class="title">Marcar vistoria como realizada?</div>
        <div class="mt-3">Para marcar uma vistoria como realizada você precisa anexar uma foto referente a vistoria.</div>
      </v-card-title>
      <v-card-text>
        <file-input
          accept="image/*"
          icon="add_a_photo"
          v-model="form.fields.fotoFilename"
          @formData="onFilePicked"
          label="Selecionar foto"
          :key="inputKey">
        </file-input>
        <v-text-field
          v-model="form.fields.legenda"
          label="Legenda"
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="error--text" flat @click.native="descartar">Ainda não</v-btn>
        <v-btn class="secondary--text" flat @click.native="onSubmit">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { apiURL } from '@/config'
  import FileInput from '../Utils/FileInput'

  export default {
    props: ['vistoriaId', 'imovelId'],
    components: {
      FileInput
    },
    data () {
      return {
        dialog: false,
        inputKey: Math.random(),
        form: {
          fields: {
            tipo: 'geral',
            legenda: '',
            foto: null,
            fotoFilename: ''
          }
        }
      }
    },
    methods: {
      onFilePicked (event) {
        this.form.fields.foto = event
      },
      descartar () {
        this.dialog = false
        this.form.fields.legenda = ''
        this.form.fields.foto = null
        this.form.fields.fotoFilename = ''
        this.inputKey = Math.random()
        this.errors.clear()
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const fieldsFormatados = {
              id: this.imovelId,
              tipo: this.form.fields.tipo,
              legenda: (this.form.fields.legenda.length > 1) ? this.form.fields.legenda : 'Vistoria realizada',
              foto: this.form.fields.foto,
              fotoFilename: this.form.fields.fotoFilename
            }

            this.$store.dispatch('fotos/adicionarFoto', { fields: fieldsFormatados }).then((response) => {
              if (response !== false) {
                axios.patch(`${apiURL}/vistoria/realizar/${this.vistoriaId}`).then(() => {
                  this.$store.dispatch('imoveis/loadImovel', { id: this.imovelId })
                  this.descartar()
                }).catch((error) => {
                  console.error('Erro ao finalizar vistoria', error)
                  this.$store.dispatch('utils/showSnackbar', {
                    text: 'Servidor indisponível. Tente novamente mais tarde.'
                  })
                }).then(() => {
                  this.$store.dispatch('utils/hideLoading')
                })
              }
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VistoriaRealizar.vue?e6e11a68